var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{class:{ 'position-relative': true, 'no-cursor': _vm.noCursor, 'no-overflow': _vm.noOverflow },attrs:{"color":"black","height":"100%","width":"100%","tile":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }